{
	"eventReports": {
		"refunded": {
			"zigTable": "Table Zig",
			"zigTag": "Carte Zig",
			"zigFicha": "Jeton Zig"
		}
	}
}
